// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__aBiyl","empty":"ModalGraph_empty__1Zely"};